import LoadingPage from '@components/loading/LoadingPage'
import PageLayout from '@components/page/PageLayout'
import { IRequestDashboardData } from '@interfaces/api/IDashboard'
import { Button, Flex, Paper } from '@mantine/core'
import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import Dashboard from '@api/Dashboard'
import { singleYearDashboardAgencyOptions, singleYearDashboardOtherOptions, singleYearDashboardProjectOptions } from '@config/dashboard'

const DashboardPresent = () => {
  const { state: params }: { state: IRequestDashboardData } = useLocation()
  const navigate = useNavigate()
  const dashboard = Dashboard.useGetDashBoardData(params)
  const pageTitle = `สรุปผลการดำเนินโครงการประจำปีงบประมาณ ${Number(params?.start_budget_year) + 543} ${params?.end_budget_year ? '- ' + (Number(params?.end_budget_year) + 543) : ''}`

  useEffect(() => {
    if (!params?.start_budget_year) {
      navigate('/dashboard')
    }
  })

  if (dashboard.isLoading) {
    return <LoadingPage />
  }

  if (!dashboard.data) {
    return <PageLayout pageTitle={pageTitle}>ไม่พบข้อมูล</PageLayout>
  }

  return (
    <PageLayout pageTitle={pageTitle}>
      <Paper mb="lg" className="noprint">
        <Button mr="lg" onClick={() => window.print()}>
          ดาวน์โหลด PDF
        </Button>
        <Button variant="light" component={Link} to="/dashboard" mr="lg">
          ย้อนกลับ
        </Button>
      </Paper>
      <Flex direction="column">
        {singleYearDashboardProjectOptions
          .filter((option) => params[option.key])
          .map((option, index) => {
            const Component = option.component
            return Component ? (
              <div key={option.key} className={index === 0 ? '' : 'pagebreak'}>
                <Component title={option.label} data={dashboard.data[option.key]} />
              </div>
            ) : null
          })}
        {singleYearDashboardAgencyOptions
          .filter((option) => params[option.key])
          .map((option) => {
            const Component = option.component
            return Component ? (
              <div key={option.key} className="pagebreak">
                <Component title={option.label} data={dashboard.data[option.key]} />
              </div>
            ) : null
          })}
        {singleYearDashboardOtherOptions
          .filter((option) => params[option.key])
          .map((option) => {
            const Component = option.component
            return Component ? (
              <div key={option.key} className="pagebreak">
                <Component title={option.label} data={dashboard.data[option.key]} />
              </div>
            ) : null
          })}
      </Flex>
    </PageLayout>
  )
}

export default DashboardPresent
